import { API } from "../api";
import { url } from "../constants";
import { IBusinessLogoResponse } from "./types";
import { validateArgs } from "../utils";

export class BusinessLogoAPIService {
  constructor(private api: API) {}

  private normalizeResponse(data: any): IBusinessLogoResponse {
    return {
      url: data?.business_logo ?? data?.url,
      updated_at: data?.updated_at,
      business_logo_dimension_warnings:
        data?.business_logo_dimension_warnings ?? data?.dimensionWarnings,
    };
  }

  async getLogo(customerId: string): Promise<IBusinessLogoResponse> {
    validateArgs(customerId);

    const response = await this.api.get<IBusinessLogoResponse>(
      url.businessLogo.replace(":customerId", customerId),
    );

    return this.normalizeResponse(response?.data);
  }

  async uploadLogo(
    customerId: string,
    file: File,
  ): Promise<IBusinessLogoResponse> {
    validateArgs(customerId, file);

    const formData = new FormData();
    // Backend expects the uploaded logo under the "Logo" field name
    formData.append("logo", file);

    const response = await this.api.put<IBusinessLogoResponse>(
      url.businessLogo.replace(":customerId", customerId),
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return this.normalizeResponse(response?.data);
  }

  async deleteLogo(customerId: string): Promise<void> {
    validateArgs(customerId);

    await this.api.delete(url.businessLogo.replace(":customerId", customerId));
  }
}
